var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7385 3.66666C5.63047 3.66666 4.91666 4.75099 4.91666 5.83332V14.5833C4.91666 15.6657 5.63047 16.75 6.7385 16.75H13.6782C14.7862 16.75 15.5 15.6657 15.5 14.5833V5.83332C15.5 4.75099 14.7862 3.66666 13.6782 3.66666H6.7385ZM5.91666 5.83332C5.91666 5.07471 6.38646 4.66666 6.7385 4.66666H13.6782C14.0302 4.66666 14.5 5.07471 14.5 5.83332V14.5833C14.5 15.3419 14.0302 15.75 13.6782 15.75H6.7385C6.38646 15.75 5.91666 15.3419 5.91666 14.5833V5.83332ZM7.58332 6.08332C7.30718 6.08332 7.08332 6.30718 7.08332 6.58332C7.08332 6.85947 7.30718 7.08332 7.58332 7.08332H12.8333C13.1095 7.08332 13.3333 6.85947 13.3333 6.58332C13.3333 6.30718 13.1095 6.08332 12.8333 6.08332H7.58332Z",
    fill: "#676879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.71210c5ae452a411749933f14a6fad0e.svg";
export { ForwardRef as ReactComponent };